export default __webpack_public_path__ + "static/media/ThinkWedding.a5d8b879bbfcacdb350b97cda5122642.webp";